import React, { useState, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import UserContext from './user.jsx';

import api_json from '../api/json.js';

import { CircularProgress } from '@mui/material';

const JSONTimelineContext = React.createContext();

function JSONTimelineProvider({ children }) {
	const [json, json_set] = useState(undefined);
	const { session } = useContext(UserContext);
	const { app_uid } = useParams();

	const store = {
		get json() {
			return json;
		},
		set_json: async (data) => {
			await api_json.save({ data, session, app_uid });
			json_set(data);
		},
		get_home() {
			return json?.home;
		},
		set_home: async (home) => {
			await store.set_json({ ...json, home});
		},
		get_sections() {
			return json?.sections || [];
		},
		set_sections: async (sections) => {
			await store.set_json({ ...json, sections });
		},
		get_popups() {
			return json?.popups || [];
		},
		set_popups: async (popups) => {
			await store.set_json({ ...json, popups });
		},
		get_maps() {
			return json?.maps || [];
		},
		set_maps: async (maps) => {
			await store.set_json({ ...json, maps });
		},
	};

	useEffect(() => {
		if(!app_uid || !session) return;
		(async () => {
			json_set(await api_json.get({ session, app_uid }));
		})();
	}, [app_uid, session]);

	return <JSONTimelineContext.Provider value={store}>{children}</JSONTimelineContext.Provider>;
}

function JSONTimelineDeffer({ children }) {
	const context = useContext(JSONTimelineContext);
	const { app_uid } = useParams();

	if (!app_uid) return <CircularProgress size={100} sx={{ mx: 'auto', mt: 20, display: 'block' }} />;

	if (!context.json) return <CircularProgress size={100} sx={{ mx: 'auto', mt: 20, display: 'block' }} />;

	return children;
}

export default JSONTimelineContext;
export { JSONTimelineProvider, JSONTimelineDeffer };
